export default __webpack_public_path__ + "static/brand-colors-light-c8acf7a8b1fc134df05e40654c8e93735ee21ea29e8b7bb2709588ed96491aed.png";